/** @jsx jsx */
import { jsx } from '@emotion/core';

import * as S from './styles';

type StepIconType = {
  icon?: JSX.Element;
  size?: 'large' | 'medium';
  status?: 'start' | 'first' | 'done' | 'next' | 'disabled';
};

const StepIcon = ({
  icon,
  size = 'medium',
  status = 'done',
}: StepIconType): JSX.Element => (
  <S.Circle className={`${status} ${size}`}>{icon}</S.Circle>
);

export default StepIcon;
